module.exports = __webpack_public_path__ + "res/22-img_game_bg.beb2f7adfa2f851b6debc546a060223a.png";